export const storeApi = "https://mobile.jeffy.sg/api/entry/getstoreinfo/";

// local url
// export const returnUrl = "http://localhost:3000/#/viewCart/processing/index.js";

// live url

export const returnUrl =
  "https://h5ordering.mycw.in/#/viewCart/processing/index.js";
